function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  d: "M17.1818 18.1818C17.1818 18.7341 16.7341 19.1818 16.1818 19.1818H15.8182C15.2659 19.1818 14.8182 18.7341 14.8182 18.1818V15.4545C14.8182 14.9023 15.2659 14.4545 15.8182 14.4545H16.1818C16.7341 14.4545 17.1818 14.9023 17.1818 15.4545V18.1818ZM17.1818 22.9091C17.1818 23.4614 16.7341 23.9091 16.1818 23.9091H15.8182C15.2659 23.9091 14.8182 23.4614 14.8182 22.9091V22.5455C14.8182 21.9932 15.2659 21.5455 15.8182 21.5455H16.1818C16.7341 21.5455 17.1818 21.9932 17.1818 22.5455V22.9091ZM3.86902 25.9535C3.48306 26.6202 3.96411 27.4545 4.73445 27.4545H27.2656C28.0359 27.4545 28.5169 26.6202 28.131 25.9535L16.8654 6.49483C16.4803 5.82954 15.5197 5.82954 15.1346 6.49483L3.86902 25.9535Z"
});

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2315abe3.svg";
export { ForwardRef as ReactComponent };